import templateUrl from 'emun.salesrep/territory-manager/zipcode/zipcode-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
//import RegionPrompt from "emun.salesrep/territory-manager/region/region-prompt";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import ZipcodePrompt from "emun.salesrep/territory-manager/zipcode/zipcode-prompt"

class ZipcodeListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.query = new AutoQuery({
			url: 'QueryZipcodes.json',
			autoLoad: true,
			hideLeftNav: true
		});
		let $rootScope = resolve("$rootScope");
		$rootScope.$on("zipcodeSaved", () => $ctrl.query.load(true));
    }
	create() {
		const $ctrl = this;
		ZipcodePrompt.open({ zipcode: "", zipcodeId: "" });
	}

	edit(zipcode) {
		const $ctrl = this;
		ZipcodePrompt.open({ zipcode: zipcode, zipcodeId: zipcode.id });
	}

	delete(zipcode) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to delete " + zipcode.id, "Delete Zipcode?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteZipcode.json", territory)
					.then(function () {
						return $ctrl.query.load(true);
					})
					.catch(

					);
			});
	}
}

let ZipcodeList = {
	controller: ZipcodeListController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}

export default ZipcodeList;
